import React, {useEffect, useRef, useState, useImperativeHandle, forwardRef} from 'react'
import st from './index.scss'

import SVGAPlayer from 'svgaplayerweb';
/**
 *
 * SVGA组件
 * github：https://github.com/svga/SVGAPlayer-Web/blob/HEAD/README.zh.md
 * @param { string } url svga线上地址 （不可以跨域 目前集中上传到 oss上的zhongheschool 搜索 svga文件夹 里面在单独创建文件夹上传）
 * @param { number } loop 动画循环次数，默认值为 0，表示无限循环
 * @param { number } width 传入px
 * @param { number } height 传入px
 * @param { Bool } clearsAfterStop 默认值为 true，表示当动画结束时，清空画布
 *
 *
 * @Callback onLoads 加载完成回调
 * @Callback onFinished 动画结束回调
 * @Callback onFrame 动画每一帧回调
 *
 *  例:
 *    <Svga
 *     url={'https://osscdn.zhongheschool.com/svga/activity/2023618Activity/jingtai_all'}
 *     loop={1}
 *     width={750}
 *     height={1334}
 *     onLoads={() => {console.log('加载完成')}}
 *     onFinished={() => {console.log('动画结束')}}
 *    />
 * @Function pauseAnimation 暂停在当前帧
 * @Function startAnimations 开始动画
 *  例：
 *    const mySvga = useRef();
 *    mySvga?.current?.pauseAnimation() //暂停在当前帧
 *    <Svga ref={mySvga} />
 *
 *
 *  目前动画不自动播放，需要手动在onLoads调用startAnimations()
 *  @return
 */
export default forwardRef(function Svga({ url, loop, width, height, clearsAfterStop=true, onLoads, onFinished, onFrame, ...props },ref) {
    const playerRef = useRef();
    useImperativeHandle(ref, () => ({
        pauseAnimation:() => { pauseAnimation ()},
        startAnimations:() => {startAnimations ()}
    }))
    //rem转px （canvas用）
    // function remToPx(rem) {
    //     return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    //   }
    // 停止动画
    function pauseAnimation (){
        console.log('停止')
        if(!playerRef.current) return
        playerRef?.current.pauseAnimation();
        playerRef?.current.stepToFrame(0);
    }
    //动画开始
    function startAnimations(){
        console.log('开始')
        if(!playerRef.current) return
        playerRef?.current.startAnimation();
    }

    useEffect(() => {
      const player = new SVGAPlayer.Player(playerRef.current);
      const parser = new SVGAPlayer.Parser();
      playerRef.current = player;
      parser.load(url, (videoItem) => {
        player.setVideoItem(videoItem);
          // setIsdisplay('block')
          player.startAnimation();//开始动画。如果不开始  canvas不初始化宽高 宽高不受控制
          player.pauseAnimation();//动画默认暂停，（如需要默认开启动画，在外部调用startAnimation开始动画）
          player.stepToFrame(0);//设置为第一帧并暂停
          onLoads && onLoads();
        });
        //结束
        player.onFinished(function() {
          console.log('结束')
          onFinished && onFinished()
        });
        //
        player.onFrame(function(frame) {
          onFrame && onFrame(frame)
        })
        player.loops = loop ? loop : 0;
        player.clearsAfterStop = clearsAfterStop;//默认值为 true，表示当动画结束时，清空画布

        return () => {
          player.clear();
        };
      }, [url, loop]);

      return (
        <canvas
          {...props}
          ref={playerRef}
          width={width}
          height={height}
        ></canvas>
      );
})
